import grapesjs from 'drapcode-builder';
import gjsBootstrap4Plugin from 'drapcode-bootstrap';
import backgroundStyle from 'drapcode-background';
import commonPlugin from 'drapcode-common';
import { pluginCode } from 'drapcode-constant';
import styleFilter from 'grapesjs-style-filter';
import parserPostCSS from 'grapesjs-parser-postcss';
import { storageManager } from '../../common/utils/geditor_utils';
import { styleManager } from '../../common/utils/styleManagerSectors';

export const resetGeditor = () => {
  if (grapesjs.editors && grapesjs.editors.length > 0) {
    try {
      grapesjs.editors[0].destroy();
      const editor = grapesjs.editors[0];
      console.log('%c🚀 ~ resetGeditor ~ editor:', 'color:yellow', editor);
      if (editor) {
        editor.select();
        setTimeout(() => {
          editor.destroy();
        }, 0);
      }
    } catch (err) {
      console.error('Warning: Error while resetting grapesjs editor:', err);
    }
    grapesjs.editors.splice(0, grapesjs.editors.length);
  }
};

const geditorBuilder = ({
  uri,
  projectId,
  version,
  token,
  collections,
  events,
  externalApis,
  assets,
  bindCollectionOptions,
  installedPlugins,
  snippetCollectionTraitOptions,
  project,
}) => {
  console.log('==> installedPlugins :>> ', installedPlugins);
  if (events && events.length > 0) {
    events.sort((a, b) => a.eventTitle.localeCompare(b.eventTitle));
  }
  const { collection: pageCollection } = snippetCollectionTraitOptions.collection
    ? snippetCollectionTraitOptions
    : bindCollectionOptions;
  let snippetType = '';
  if (snippetCollectionTraitOptions.collection) {
    snippetType =
      snippetCollectionTraitOptions.snippet && snippetCollectionTraitOptions.snippet.snippetType
        ? snippetCollectionTraitOptions.snippet.snippetType
        : '';
  }
  const { uiFrameworkName, uiFrameworkVersion, toggleUnloadDefaultJS, toggleUnloadDefaultCSS } =
    project ? project : {};
  const jsScripts = [
    'https://cdnjs.cloudflare.com/ajax/libs/axios/0.19.2/axios.js',
    'https://cdn.jsdelivr.net/npm/apexcharts',
    'https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.14.3/umd/popper.min.js',
  ];

  if (!toggleUnloadDefaultJS) {
    jsScripts.unshift('https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js');
  }

  const styleLinks = [
    'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css',
    'https://drapcode-static.s3.amazonaws.com/style/googlefonts.min.css',
    'https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css',
  ];

  addBootstrapDependencies(
    uiFrameworkName,
    uiFrameworkVersion,
    jsScripts,
    styleLinks,
    toggleUnloadDefaultJS,
    toggleUnloadDefaultCSS,
  );
  const plugins = [];
  const commonPlugins = [];
  plugins.push('gjs-progress');
  plugins.push('form');
  plugins.push('gjs-data-table');
  plugins.push(gjsBootstrap4Plugin);
  plugins.push('gjs-data-group');
  plugins.push('gjs-child-data-group');
  plugins.push('gjs-browser-storage-setter');
  plugins.push('gjs-child-data-list');
  plugins.push('gjs-collection-form');
  plugins.push('gjs-add-remove-collection-form');
  plugins.push('gjs-search-form');
  plugins.push('gjs-page-search-form');
  plugins.push('zerocode-snippet');
  plugins.push('zerocode-subpage');
  plugins.push('custom-component');
  plugins.push('zerocode-customsegment');
  plugins.push('webconnect-event-traits');
  plugins.push('webconnect-href-traits');
  plugins.push('gjs-pagination');
  plugins.push('gjs-pre-built-section');
  plugins.push('gjs-theme-page');
  plugins.push('gjs-drapcode-icons');
  plugins.push('drapcode-carousel-traits');
  plugins.push('drapcode-card-traits');
  plugins.push('drapcode-charts');
  // plugins.push('gjs-data-group-external-api');
  // plugins.push('autocomplete');
  plugins.push('autocomplete-input');
  plugins.push('export-button');
  plugins.push('gjs-pagination-number');
  plugins.push('gjs-data-table-dynamic');
  plugins.push(styleFilter);
  plugins.push(parserPostCSS);
  plugins.push(backgroundStyle);
  plugins.push(commonPlugin);
  plugins.push('gjs-pdf-viewer');
  plugins.push('gjs-pagination-page-size');
  plugins.push('notes-widget');
  const pluginOpts = {
    form: {
      projectId,
    },
    'gjs-data-table': {
      projectId,
      pageCollection,
      collections,
    },
    'gjs-data-group': {
      projectId,
      version,
      pageCollection,
      collections,
      events,
    },
    'gjs-browser-storage-setter': {
      projectId,
      version,
      pageCollection,
      collections,
      events,
    },
    'notes-widget': {
      projectId,
      version,
      pageCollection,
      collections,
      events,
    },
    // autocomplete: { projectId, pageCollection, collections },
    'autocomplete-input': { projectId, version, pageCollection, collections },
    'export-button': { projectId },
    'gjs-child-data-group': {
      projectId,
      collections,
      pageCollection,
    },
    'gjs-child-data-list': {
      collections,
      pageCollection,
    },
    'gjs-collection-form': {
      projectId,
      version,
      pageCollection,
      collections,
      snippetType,
      installedPlugins,
    },
    'gjs-add-remove-collection-form': {
      projectId,
      bindCollectionOptions,
      collections,
    },
    'gjs-page-search-form': {
      projectId,
      version,
    },
    'zerocode-snippet': {
      projectId,
      version,
    },
    'zerocode-subpage': {
      projectId,
      version,
    },
    'custom-component': {
      projectId,
      version,
    },
    'zerocode-customsegment': {
      projectId,
      version,
    },
    'webconnect-event-traits': {
      projectId,
      version,
      events,
      token,
    },
    'webconnect-href-traits': {
      projectId,
      version,
      pageCollection,
      bindCollectionOptions,
      collections,
    },
    'gjs-pre-built-section': {
      projectId,
      version,
    },
    'gjs-theme-page': {
      projectId,
      project,
    },
    'gjs-drapcode-icons': {
      projectId,
      events,
    },
    'drapcode-carousel-traits': {
      projectId,
    },
    'drapcode-card-traits': {
      projectId,
    },
    'drapcode-charts': {
      projectId,
      version,
      collections,
      bindCollectionOptions,
      snippetCollectionTraitOptions,
      installedPlugins,
    },
    // 'gjs-data-group-external-api': {
    //   projectId,
    //   pageCollection,
    // },
    'gjs-data-table-dynamic': {
      projectId,
      version,
      pageCollection,
      collections,
      bindCollectionOptions,
      snippetCollectionTraitOptions,
      token,
      externalApis,
    },
    'gjs-user-tenant-dropdown': {
      pageCollection,
    },
    'gjs-sub-tenant-dropdown': {
      pageCollection,
    },
    'gjs-calendar': {
      projectId,
      version,
    },
    'gjs-calendar-timeslot': {
      projectId,
      version,
    },
    'gjs-date-range-filter': {
      projectId,
      version,
    },
    'action-submit': {
      projectId,
      version,
    },
    'page-list': {
      projectId,
      version,
    },
    'gjs-pagination': {
      projectId,
      pageCollection,
      collections,
    },
    'gjs-pagination-number': {
      projectId,
      pageCollection,
      collections,
    },
    'gjs-pagination-page-size': {
      projectId,
      pageCollection,
      collections,
    },
    'gjs-pdf-viewer': {
      projectId,
      version,
      pageCollection,
      collections,
      events,
    },
  };

  // Integrate Drapcode AI Components based on AI Plugin
  plugins.push('drapcode-ai-components');
  pluginOpts['drapcode-ai-components'] = {
    projectId,
    version,
    token,
    collections,
    project,
  };

  const isSearchHistoryPluginInstalled = installedPlugins.some(
    (e) => e.code === pluginCode.DATA_FORM_SEARCH_HISTORY,
  );
  pluginOpts['gjs-search-form'] = {
    projectId,
    collections,
    version,
    isSearchHistoryPluginInstalled,
  };

  const loginSignup = installedPlugins.find((e) => e.code === pluginCode.LOGIN);
  if (loginSignup) {
    plugins.push('gjs-login-form');
    plugins.push('gjs-sign-up-form');
    plugins.push('gjs-change-passowrd-form');
    pluginOpts['gjs-login-form'] = {
      projectId,
      version,
      collections,
    };
    pluginOpts['gjs-sign-up-form'] = {
      projectId,
      version,
      collections,
    };
    pluginOpts['gjs-change-passowrd-form'] = {
      projectId,
      version,
    };
  }
  const plaid = installedPlugins.find((e) => e.code === pluginCode.PLAID);
  if (plaid) {
    plugins.push('plaid');
    pluginOpts['plaid'] = {
      projectId,
      events,
    };
  }
  const stripePaymentMethodPlugin = installedPlugins.find(
    (e) => e.code === pluginCode.STRIPE_PAYMENT_METHODS,
  );
  if (stripePaymentMethodPlugin) {
    plugins.push('stripe-payment-methods');
    pluginOpts['stripe-payment-methods'] = {
      projectId,
      version,
      collections,
      pageCollection,
    };
    plugins.push('stripe-payment-methods-list');
    pluginOpts['stripe-payment-methods-list'] = {
      projectId,
      version,
      collections,
      pageCollection,
    };
  }
  const signaturePadPlugin = installedPlugins.find((e) => e.code === pluginCode.SIGNATURE_PAD);
  if (signaturePadPlugin) {
    plugins.push('signature-pad');
    pluginOpts['signature-pad'] = {
      projectId,
      version,
      collections,
      pageCollection,
    };
  }
  const multiTenantPlugin = installedPlugins.find((e) => e.code === pluginCode.MULTI_TENANT_SAAS);
  if (multiTenantPlugin) {
    plugins.push('gjs-user-tenant-dropdown');
    pluginOpts['gjs-user-tenant-dropdown'] = {
      projectId,
      multiTenantPlugin,
      collections,
    };
    const { setting } = multiTenantPlugin;
    if (setting) {
      if (setting.userSettingsCollection) {
        plugins.push('gjs-role-mapping-dropdown');
        pluginOpts['gjs-role-mapping-dropdown'] = {
          projectId,
          version,
          multiTenantPlugin,
          collections,
        };
      }
      if (setting.subTenantCollection) {
        plugins.push('gjs-sub-tenant-dropdown');
        pluginOpts['gjs-sub-tenant-dropdown'] = {
          projectId,
          multiTenantPlugin,
          collections,
        };
      }
    }
  }
  const permissionPlugin = installedPlugins.find((e) => e.code === pluginCode.PERMISSIONS_MANAGE);
  if (permissionPlugin) {
    plugins.push('permission');
    pluginOpts['permission'] = {
      projectId,
      version,
      events,
      multiTenantPlugin,
      collections,
    };
  }

  const messagingPlugin = installedPlugins.find((e) => e.code === pluginCode.MESSAGING);
  if (messagingPlugin) {
    plugins.push('messaging');
    pluginOpts['messaging'] = {
      projectId,
      version,
      events,
      collections,
    };
  }
  const emailOTPAuthenticatorPlugin = installedPlugins.find(
    (e) => e.code === pluginCode.EMAIL_OTP_AUTHENTICATOR,
  );
  const smsOTPAuthenticatorPlugin = installedPlugins.find(
    (e) => e.code === pluginCode.SMS_OTP_AUTHENTICATOR,
  );
  const emailOTPConsentValidator = installedPlugins.find(
    (e) => e.code === pluginCode.EMAIL_OTP_CONSENT_VALIDATOR,
  );
  const smsOTPConsentValidator = installedPlugins.find(
    (e) => e.code === pluginCode.SMS_OTP_CONSENT_VALIDATOR,
  );
  if (
    emailOTPAuthenticatorPlugin ||
    smsOTPAuthenticatorPlugin ||
    emailOTPConsentValidator ||
    smsOTPConsentValidator
  ) {
    plugins.push('gjs-otp-authenticator');
    pluginOpts['gjs-otp-authenticator'] = {
      projectId,
      version,
      pageCollection,
      collections,
      events,
    };
    plugins.push('gjs-otp-generation-form');
    pluginOpts['gjs-otp-generation-form'] = {
      projectId,
      version,
      pageCollection,
      collections,
      events,
    };
  }
  const typesensePlugin = installedPlugins.find((e) => e.code === pluginCode.TYPESENSE_SEARCH);
  if (typesensePlugin) {
    plugins.push('gjs-typesense-search');
    pluginOpts['gjs-typesense-search'] = {
      projectId,
      version,
      pageCollection,
      collections,
      typesensePlugin,
    };
  }

  const socketPlugin = installedPlugins.find((e) => e.code === pluginCode.SOCKET_IO);
  if (socketPlugin) {
    plugins.push('gjs-socket-alert');
    pluginOpts['gjs-socket-alert'] = {
      projectId,
      version,
      collections,
      socketPlugin,
    };
  }

  const boxPlugin = installedPlugins.find((e) => e.code === pluginCode.BOX);
  if (boxPlugin) {
    plugins.push('gjs-box-folder-list');
    pluginOpts['gjs-box-folder-list'] = {
      projectId,
      version,
    };
  }

  if (bindCollectionOptions) {
    plugins.push('webconnect-collection-traits');
    plugins.push('webconnect-collection-img-traits');
    plugins.push('webconnect-iframe-traits');
    plugins.push('webconnect-collection-video-traits');
    plugins.push('drapcode-collection-audio-traits');
    plugins.push('gjs-calendar');
    plugins.push('gjs-calendar-timeslot');
    plugins.push('gjs-date-range-filter');
    plugins.push('action-submit');
    plugins.push('page-list');
    pluginOpts['gjs-progress'] = {
      bindCollectionOptions,
      projectId,
      collections,
      version,
      installedPlugins,
    };
    pluginOpts['webconnect-collection-traits'] = {
      bindCollectionOptions,
      snippetCollectionTraitOptions,
      projectId,
      version,
      token,
      collections,
      externalApis,
      installedPlugins,
    };
    pluginOpts['webconnect-collection-img-traits'] = {
      bindCollectionOptions,
      snippetCollectionTraitOptions,
    };
    pluginOpts['webconnect-iframe-traits'] = {
      bindCollectionOptions,
      snippetCollectionTraitOptions,
    };
    pluginOpts['webconnect-collection-video-traits'] = {
      bindCollectionOptions,
      snippetCollectionTraitOptions,
    };
    pluginOpts['drapcode-collection-audio-traits'] = {
      bindCollectionOptions,
      snippetCollectionTraitOptions,
    };
    pluginOpts['gjs-calendar'] = {
      bindCollectionOptions,
      snippetCollectionTraitOptions,
      collections,
      pageCollection,
      externalApis,
      events,
    };
    pluginOpts['gjs-calendar-timeslot'] = {
      bindCollectionOptions,
      snippetCollectionTraitOptions,
      collections,
      pageCollection,
      externalApis,
      events,
    };
    pluginOpts['gjs-date-range-filter'] = {
      collections,
      projectId,
    };
    pluginOpts['action-submit'] = {
      bindCollectionOptions,
      snippetCollectionTraitOptions,
      collections,
      pageCollection,
      externalApis,
      events,
    };
    pluginOpts['page-list'] = {
      collections,
      projectId,
    };
  }

  const subscribe = installedPlugins.find((e) => e.code === pluginCode.SUBSCRIBE);
  if (subscribe) {
    plugins.push('gjs-subscriber-form');
    pluginOpts['gjs-subscriber-form'] = {
      projectId,
    };
  }
  const chatBotMessaging = installedPlugins.find(
    (e) => e.code === pluginCode.CHATGPT_CHATBOT_MESSAGING,
  );
  if (chatBotMessaging) {
    plugins.push('chat-bot-messaging');
    pluginOpts['chat-bot-messaging'] = {
      projectId,
    };
  }

  const aiChatBot = installedPlugins.find((e) => e.code === pluginCode.AI_CHATBOT);
  if (aiChatBot) {
    console.log('==> aiChatBot :>> ', aiChatBot);
    plugins.push('ai-chatBot-messaging');
    pluginOpts['ai-chatBot-messaging'] = {
      projectId,
    };
  }

  const totpPlugin = installedPlugins.find((e) => e.code === pluginCode.TWO_FACTOR_AUTHENTICATION);
  if (totpPlugin) {
    plugins.push('totp');
    pluginOpts['totp'] = {
      projectId,
    };
  }

  const imaginePayPlugin = installedPlugins.find((e) => e.code === pluginCode.IMAGINE_PAY);
  if (imaginePayPlugin) {
    plugins.push('imagine-pay');
    pluginOpts['imagine-pay'] = {
      projectId,
      collections,
      pageCollection,
      bindCollectionOptions,
      snippetCollectionTraitOptions,
    };
  }

  const marketplaceCart = installedPlugins.find((e) => e.code === pluginCode.MARKETPLACE_CHECKOUT);
  const stripe = installedPlugins.find((e) => e.code === pluginCode.STRIPE);
  if (marketplaceCart && stripe) {
    plugins.push('stripe-payment');
    plugins.push('gjs-marketplace-form');
    pluginOpts['stripe-payment'] = {
      projectId,
      stripeApiKey: stripe ? stripe.setting.published_key : '',
    };
    pluginOpts['gjs-marketplace-form'] = {
      projectId,
      collections,
    };
  }
  const googleMap = installedPlugins.find((e) => e.code === pluginCode.GOOGLE_MAP);
  if (googleMap) {
    plugins.push('gjs-data-map');
    pluginOpts['gjs-data-map'] = {
      projectId,
      collections,
    };
  }
  const atomChat = installedPlugins.find((e) => e.code === pluginCode.ATOM_CHAT);
  if (atomChat) {
    plugins.push('atomchat');
    pluginOpts['atomchat'] = {
      projectId,
      appId: atomChat ? atomChat.setting.api_id : '',
      authKey: atomChat ? atomChat.setting.auth_key : '',
    };
  }
  const snipcart = installedPlugins.find((e) => e.code === pluginCode.SNIPCART);
  if (snipcart) {
    plugins.push('snipcart-ecommerce');
    pluginOpts['snipcart-ecommerce'] = {
      projectId,
      snipcartApiKey: snipcart ? snipcart.setting.secret_key : '',
      collections,
    };
  }
  const stripeConnect = installedPlugins.find((e) => e.code === pluginCode.STRIPE_CONNECT);
  if (stripeConnect) {
    plugins.push('gjs-stripe-connect-buy');
    pluginOpts['gjs-stripe-connect-buy'] = {
      projectId,
      stripeApiKey: stripeConnect ? stripeConnect.setting.published_key : '',
      bindCollectionOptions,
      snippetCollectionTraitOptions,
      collections,
      version,
      installedPlugins,
    };
  }

  const bngPayment = installedPlugins.find((e) => e.code === pluginCode.BNG_PAYMENT);
  if (bngPayment) {
    plugins.push('gjs-bng-payment');
    pluginOpts['gjs-bng-payment'] = {
      projectId,
      bngConfig: bngPayment ? bngPayment.setting : { lineItemType: '' },
      bindCollectionOptions,
      snippetCollectionTraitOptions,
      collections,
    };
  }

  const fluidPay = installedPlugins.find((e) => e.code === pluginCode.FLUID_PAY);
  if (fluidPay) {
    plugins.push('fluid-pay');
    pluginOpts['fluid-pay'] = {
      projectId,
      events,
      fluidConfig: fluidPay ? fluidPay.setting : { apiKey: '' },
      bindCollectionOptions,
      snippetCollectionTraitOptions,
      collections,
    };
  }

  const youtube = installedPlugins.find((e) => e.code === 'YOUTUBE');
  if (youtube) {
    commonPlugins.push({ youtube });
  }

  console.log('%c🚀 ~ geditorBuilder SM:', 'color:yellow', uri);
  return grapesjs.init({
    container: '#gjs',
    storageManager: storageManager(uri, projectId),
    allowScripts: 1,
    fromElement: true,
    layerManager: {
      appendTo: '#layer-manager',
    },
    blockManager: {
      appendTo: '#blocks',
      appendOnDblClick: true,
    },
    assetManager: {
      upload: false,
      assets: assets.map((asset) => `${process.env.REACT_APP_S3_URL}${asset.key}`),
      storeOnChange: false,
      storeAfterUpload: false,
    },
    plugins,
    pluginsOpts: {
      ...pluginOpts,
      [commonPlugin]: {
        ...commonPlugins,
        projectId: projectId,
        version: version,
        uri: uri,
      },
      [styleFilter]: {},
      backgroundStyle: {},
    },
    styleManager: styleManager(project),
    selectorManager: {
      componentFirst: true,
    },
    richTextEditor: {
      actions: ['bold', 'italic', 'underline', 'strikethrough'],
    },
    canvas: {
      scripts: jsScripts,
      styles: styleLinks,
    },
  });
};

const addBootstrapDependencies = (
  uiFrameworkName,
  uiFrameworkVersion,
  jsScripts,
  styleLinks,
  toggleUnloadDefaultJS,
  toggleUnloadDefaultCSS,
) => {
  if (uiFrameworkName && uiFrameworkName === 'Bootstrap') {
    switch (uiFrameworkVersion) {
      case '4.5':
        if (!(toggleUnloadDefaultJS && toggleUnloadDefaultCSS))
          jsScripts.push(
            'https://cdn.jsdelivr.net/npm/bootstrap@4.5.3/dist/js/bootstrap.bundle.min.js',
          );
        if (!toggleUnloadDefaultCSS)
          styleLinks.unshift(
            'https://cdn.jsdelivr.net/npm/bootstrap@4.5.3/dist/css/bootstrap.min.css',
          );
        break;
      case '4.6':
        if (!(toggleUnloadDefaultJS && toggleUnloadDefaultCSS))
          jsScripts.push(
            'https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/js/bootstrap.bundle.min.js',
          );
        if (!toggleUnloadDefaultCSS)
          styleLinks.unshift(
            'https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/css/bootstrap.min.css',
          );
        break;
      case '5.2':
        if (!(toggleUnloadDefaultJS && toggleUnloadDefaultCSS))
          jsScripts.push(
            'https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/js/bootstrap.bundle.min.js',
          );
        if (!toggleUnloadDefaultCSS)
          styleLinks.unshift(
            'https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/css/bootstrap.min.css',
          );
        break;

      default:
        if (!(toggleUnloadDefaultJS && toggleUnloadDefaultCSS))
          jsScripts.push('https://maxcdn.bootstrapcdn.com/bootstrap/4.4.1/js/bootstrap.min.js');
        if (!toggleUnloadDefaultCSS)
          styleLinks.unshift(
            'https://maxcdn.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css',
          );
        break;
    }
  }
};

export default geditorBuilder;
